import Vue from 'vue'
import {
	ToastPlugin,
	ModalPlugin
} from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import 'element-ui/lib/theme-chalk/index.css';

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'


// 6rd party plugins
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import '@/libs/common'
import '@/libs/axios'
import '@/libs/dictionary'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

import '@core/scss/vue/libs/vue-sweetalert.scss';
import '@core/scss/vue/libs/vue-select.scss';


Vue.config.productionTip = false
new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
